import React, { createContext, useState } from "react";
import { LoadScript } from "@react-google-maps/api";
// import orderLoader from "../../public/images/home/place-order-loader.gif";

export const LocationContext = createContext();
const GoogleMapsContext = createContext();

export const LocationContextProvider = ({ children }) => {
  const [location, setLocation] = useState("");
  const [position, setPosition] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const libraries = ["places"];
  const googleMapsApiKey = "AIzaSyARhFVFYkqqbvJ1moa2_73JMEa8Z5LeVaM";

  const handlePosition = (value) => {
    setPosition(() => ({
      value,
    }));
  };
  const deleteAddress = () => {
    if (location) {
      setLocation("");
    }
  };
  const contextValue = {
    location,
    setLocation,
    handlePosition,
    position,
    deleteAddress,
  };

  return (
    <LoadScript
      googleMapsApiKey={googleMapsApiKey}
      libraries={libraries}
      onLoad={() => setIsLoaded(true)}
      loadingElement={
        <div className="order-loader">
          {/* <img src={orderLoader} alt="orderLoader" className="loader-img" /> */}
        </div>
      }>
      <GoogleMapsContext.Provider value={isLoaded}>
        <LocationContext.Provider value={contextValue}>
          {children}
        </LocationContext.Provider>
      </GoogleMapsContext.Provider>
    </LoadScript>
  );
};
